import React from "react";
import { Link } from "react-router-dom";
import "../styles/footer.css";

const FOOTER_COLUMNS = [
  {
    heading: "Product",
    links: [
      { label: "Product Overview", to: "/product" },
      { label: "Application Modules", to: "/product/modules" },
      { label: "Features", to: "/features" },
      { label: "How It Works", to: "/features/how-it-works" },
    ],
  },
  {
    heading: "Solutions",
    links: [
      { label: "Attendance & Verification", to: "/solutions/attendance" },
      { label: "Leave & Permission", to: "/solutions/leave-permission" },
      { label: "Payroll & Deductions", to: "/solutions/payroll" },
      { label: "Admin Dashboard", to: "/solutions/admin-dashboard" },
    ],
  },
  {
    heading: "Company",
    links: [
      { label: "Benefits", to: "/benefits" },
      // { label: "Resources", to: "/resources" },
      { label: "About", to: "/about" },
      { label: "Request a Demo", to: "/contact" },
    ],
  },
];

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer-top">
        <div className="footer-brand">
          <Link to="/" className="footer-brand-link" aria-label="MPeoples HRMS home">
            <span className="footer-brand-mark" aria-hidden="true">
              <img src="/logo.png" alt="" />
            </span>
            <span>MPeoples HRMS</span>
          </Link>
          <p className="footer-tagline">
            A mobile HR Management System that digitizes attendance, leave,
            permissions and payroll — backed by a web Admin Dashboard for
            HR and management.
          </p>
        </div>

        <div className="footer-columns">
          {FOOTER_COLUMNS.map((col) => (
            <div className="footer-column" key={col.heading}>
              <h4>{col.heading}</h4>
              <ul>
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="container footer-bottom">
        <p>© {year} MPeoples HRMS. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
